<div fxLayout="row" fxLayoutAlign="end end" class="version">
    <mat-form-field appearance="fill" (mouseenter)="select.open()">
      <mat-label>Version</mat-label>
      <mat-select #select (selectionChange)="changeVersion($event);select.close()" [(value)]="selectedVersion" [compareWith]="compareObjects">
        <mat-option *ngFor="let version of versionList" [value]="version" >
          {{version.attributes.display_name}} <span *ngIf="version.attributes.is_current"> (Current)</span>
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>